import {
  Users,
  BarChart3,
  ArrowUpCircle,
  ArrowDownCircle,
  CheckCircle2,
  XCircle,
  GraduationCap,
  Target,
} from "lucide-react";

const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

// Mirrors the sheet's own "KEY METRIC" table 1:1, in the same order, so the numbers here
// always match what's in the ACADEMICS tab.
const SummaryCards = ({ summary = {} }) => {
  const cards = [
    {
      title: "Total Students",
      value: summary.totalStudents || 0,
      subtitle: "Grade 10, all sections",
      icon: <Users size={18} />,
      bgColor: "bg-[#eedceb]",
      iconBg: "bg-fuchsia-700",
      subtitleColor: "text-pink-600",
    },
    {
      title: "Overall Average",
      value: formatPercent(summary.overallAverage),
      subtitle: "Student-weighted",
      icon: <BarChart3 size={18} />,
      bgColor: "bg-[#d9edf8]",
      iconBg: "bg-blue-600",
      subtitleColor: "text-sky-600",
    },
    {
      title: "Highest %",
      value: formatPercent(summary.highest),
      subtitle: "Highest overall (student)",
      icon: <ArrowUpCircle size={18} />,
      bgColor: "bg-[#e8f2d8]",
      iconBg: "bg-lime-500",
      subtitleColor: "text-lime-600",
    },
    {
      title: "Lowest %",
      value: formatPercent(summary.lowest),
      subtitle: "Lowest overall (student)",
      icon: <ArrowDownCircle size={18} />,
      bgColor: "bg-[#fde3e3]",
      iconBg: "bg-orange-500",
      subtitleColor: "text-orange-600",
    },
    {
      title: "At/Above Pass Mark",
      value: summary.atAbovePassMark || 0,
      subtitle: "Students",
      icon: <CheckCircle2 size={18} />,
      bgColor: "bg-[#daf1e5]",
      iconBg: "bg-emerald-500",
      subtitleColor: "text-emerald-600",
    },
    {
      title: "Below Pass Mark",
      value: summary.belowPassMark || 0,
      subtitle: "Students",
      icon: <XCircle size={18} />,
      bgColor: "bg-[#f4eccf]",
      iconBg: "bg-yellow-500",
      subtitleColor: "text-yellow-600",
    },
    {
      title: "Overall Pass %",
      value: formatPercent(summary.overallPassPercent),
      subtitle: "Grade 10, combined",
      icon: <GraduationCap size={18} />,
      bgColor: "bg-[#f6e3e3]",
      iconBg: "bg-red-500",
      subtitleColor: "text-red-500",
    },
    {
      title: "Pass Mark Assumption",
      value: `${summary.passMarkAssumption || 0}%`,
      subtitle: "Used for this analysis",
      icon: <Target size={18} />,
      bgColor: "bg-[#e6e0f5]",
      iconBg: "bg-purple-500",
      subtitleColor: "text-purple-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.title}
          className={`${card.bgColor} rounded-2xl p-4 transition hover:scale-[1.02]`}
        >
          <div className="mb-2 flex items-start justify-between">
            <div
              className={`${card.iconBg} flex h-8 w-8 items-center justify-center rounded-lg text-white shadow-md`}
            >
              {card.icon}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium text-slate-700">
              {card.title}
            </h3>

            <p className="mt-1 text-2xl font-bold text-slate-800">
              {card.value}
            </p>

            <p className={`mt-0.5 text-xs font-medium ${card.subtitleColor}`}>
              {card.subtitle}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
